declare global {
    interface Window {
        dataLayer: object[];
    }
}

export function gtag(..._args: unknown[]): void {
    window.dataLayer = window.dataLayer || [];

    // gtag.js only recognizes an `arguments`-like object as a command - a plain array is silently ignored
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
}
declare global {
    interface Window {
        dataLayer: object[];
    }
}

export function gtag(..._args: unknown[]): void {
    window.dataLayer = window.dataLayer || [];

    // gtag.js only recognizes an `arguments`-like object as a command - a plain array is silently ignored
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
}
